import Page2025 from './Page2025';
export default Page2025;
